export enum AD_CONFIG_SERVICE_TYPE {
    search = 'AD_SEARCH',
    advertisement = 'AD',
    request = 'AD_REQUEST',
}
